<!-- <button type=button mat-button mat-icon-button (click)="runScan()">
    <mat-icon svgIcon="scan-qrcode"></mat-icon>
</button> -->
<button mat-flat-button color="accent" (click)="runScan()"> 
    <mat-icon>qr_code</mat-icon>
</button>